export const NEOM_AREA_COORDINATES: google.maps.LatLngLiteral = {
  lng: 35.11205235821298,
  lat: 28.109574304132707,
};
